import * as React from 'react'
import { Form } from 'formik'
import Grid from '@mui/material/Grid'
import { getStyles } from './hooks/useStyles'
import { Conditions, SalesOwnership } from './FormFields'
import {
  ContentCentered,
  SettingsPage,
  FormSection,
} from '@sales-center/components'
import { PageHeader } from './PageHeader'
import { TextFieldProps } from '@mui/material/TextField'
import { Content } from './atoms'
import { useData, useHandlers } from './hooks'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useScrollToFieldError } from '@user/components/Formik/ScrollToFieldError/useScrollToFieldError'
import { RuleName } from './FormFields/RuleName'
import { RuleDescription } from './FormFields/RuleDescription'
import { useTheme } from '@mui/material/styles'

type Props = {
  isEditPage: boolean
}

export function LeadAssignmentRuleForm(props: Props) {
  const { isEditPage } = props
  const texInputProps: TextFieldProps = {
    sx: getStyles(useTheme()).input,
  }
  const { initialLoading, failed, success, salesFunnels, salesTeams, stages } =
    useData()
  const {
    onChangeSalesTeam,
    onChangeSalesFunnel,
    status: userStatus,
  } = useHandlers()

  useScrollToFieldError(true)
  return (
    <Form>
      <SettingsPage
        allowCustomTitle
        title={<PageHeader isEditPage={isEditPage} />}
        padding="0"
        fullScreen
      >
        <ContentCentered>
          {initialLoading && userStatus === 'pending' && (
            <Box pt={4.8} textAlign="center">
              <CircularProgress />
            </Box>
          )}

          {success && userStatus !== 'fail' && (
            <div>
              <Grid container>
                <Content>
                  {/* ========== F O R M ========== */}
                  <Box pt={2}>
                    <FormSection label="Name" spacing={2} maxWidth="626px">
                      <RuleName textFieldProps={texInputProps} />
                      <RuleDescription textFieldProps={texInputProps} />
                    </FormSection>

                    <Conditions
                      textFieldProps={texInputProps}
                      name="assignmentRuleConditions"
                    />
                    <SalesOwnership
                      salesFunnelStages={stages}
                      salesFunnels={salesFunnels}
                      salesTeams={salesTeams}
                      onChangeSalesTeam={onChangeSalesTeam}
                      onChangeSalesFunnel={onChangeSalesFunnel}
                    />
                  </Box>
                </Content>
              </Grid>
            </div>
          )}
          {failed && userStatus === 'fail' && (
            <Box p={2}>
              <Alert severity="error">Failed to load Form information.</Alert>
            </Box>
          )}
        </ContentCentered>
      </SettingsPage>
    </Form>
  )
}
